import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ServiceNotificationService} from "../services/service-notification.service";
declare var bootstrap: any;

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css'
})


export class NotificationsComponent implements OnInit {

   mensaje: string = '';
    typeMensaje: string = '';
  success: boolean = false;
  colors: string = '';

  constructor(
    private serviceNotifications: ServiceNotificationService
  ) {
  }

  ngOnInit() {
    this.serviceNotifications.recibeNotificacion.subscribe((data: any) => {
      const { mensaje, tipo } = data;
      this.mensaje = mensaje;
     if (tipo){
       this.typeMensaje= '<i class="bi bi-check-all"></i>'
       this.colors = 'text-bg-primary';
     }else {
       this.typeMensaje= '<i class="bi bi-x-circle"></i>'
       this.colors = 'text-bg-danger';
     }
      this.showToast();
    });
  }



  @ViewChild('liveToast') liveToast!: ElementRef;

  showToast() {
    const toast = new bootstrap.Toast(this.liveToast.nativeElement);
    toast.show();
  }

  hideToast() {
    const toast = new bootstrap.Toast(this.liveToast.nativeElement);
    toast.hide();
  }

}
